<template>
  <nav class="breadcrumbs" aria-label="Хлебные крошки">
    <ol class="breadcrumbs__list">
      <li class="breadcrumbs__item">
        <NuxtLink to="/" class="breadcrumbs__link">Главная</NuxtLink>
      </li>
      <li v-if="currentSubsection" class="breadcrumbs__item">
        <span class="breadcrumbs__separator">/</span>
        <NuxtLink :to="currentSubsection.path" class="breadcrumbs__link">
          {{ currentSubsection.title }}
        </NuxtLink>
      </li>
      <li v-if="currentCategory" class="breadcrumbs__item">
        <span class="breadcrumbs__separator">/</span>
        <NuxtLink
          :to="currentCategoryPath ?? `/read/documents/${currentCategory.slug}`"
          class="breadcrumbs__link"
        >
          {{ currentCategory.title }}
        </NuxtLink>
      </li>
      <li v-if="resolvedCurrentPageTitle" class="breadcrumbs__item">
        <span class="breadcrumbs__separator">/</span>
        <span class="breadcrumbs__current">{{ resolvedCurrentPageTitle }}</span>
      </li>
    </ol>
  </nav>
</template>

<script setup>
const props = defineProps({
  currentPageTitle: {
    type: String,
    default: null,
  },
  currentCategory: {
    type: Object,
    default: null,
  },
  currentCategoryPath: {
    type: String,
    default: null,
  },
});

const route = useRoute();

const submenuStructure = [
  // Читать
  { parent: 'read', title: 'Статьи', path: '/read/articles' },
  { parent: 'read', title: 'Памятники', path: '/read/monuments' },
  { parent: 'read', title: 'События', path: '/read/news' },
  {
    parent: 'read',
    title: 'Биографии',
    path: '/read/biographies',
  },
  {
    parent: 'read',
    title: 'Научные статьи',
    path: '/read/science',
  },
  { parent: 'read', title: 'Документы', path: '/read/documents' },

  // Смотреть
  {
    parent: 'watch',
    title: 'Все материалы',
    path: '/watch/videomaterials',
  },
  {
    parent: 'watch',
    title: 'Видеолекции',
    path: '/watch/lectures',
  },
  {
    parent: 'watch',
    title: 'Видеокурсы',
    path: '/watch/courses',
  },
  {
    parent: 'watch',
    title: 'Памятные даты',
    path: '/watch/memdates',
  },
  { parent: 'watch', title: 'Фильмы', path: '/watch/films' },

  // Слушать
  {
    parent: 'listen',
    title: 'Аудиолекции',
    path: '/listen/lectures',
  },
  { parent: 'listen', title: 'Аудиокурсы', path: '/listen/courses' },

  // Исторические карты
  {
    parent: 'historical-maps',
    title: 'Исторические карты',
    path: `/historical-maps`,
    not_nested: true,
  },

  // Энциклопедия
  {
    parent: 'encyclopedia',
    title: 'Энциклопедия',
    path: `/encyclopedia`,
    not_nested: true,
  },
];

const currentSubsection = computed(() => {
  const pathParts = route.path.split('/').filter(Boolean);

  if (pathParts.length < 2) return null;

  const section = pathParts[0];
  const subsection = pathParts[1];

  // Ищем подраздел, по текущему пути
  const matchedSubsection = submenuStructure.find((item) => {
    if (item.not_nested) return item.parent === section;
    return item.parent === section && item.path === `/${section}/${subsection}`;
  });

  return matchedSubsection || null;
});

const resolvedCurrentPageTitle = computed(() => {
  if (props.currentPageTitle) {
    return props.currentPageTitle;
  }
  // Если не передан currentPageTitle
  const pathParts = route.path.split('/').filter(Boolean);

  // Если текущий путь — подраздел
  if (pathParts.length === 2) return null;

  // Иначе — это конкретная сущность
  return pathParts[pathParts.length - 1]?.replace(/-/g, ' ') || null;
});
</script>

<style scoped>
.breadcrumbs {
  margin: 1rem 0 2rem;
  font-size: 0.875rem;
}

.breadcrumbs__list {
  display: inline-flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: 0;
}

.breadcrumbs__item {
  display: flex;
  align-items: center;
}

.breadcrumbs__separator {
  margin: 0 0.5rem;
  color: #666;
}

.breadcrumbs__link {
  color: #a10009;
  text-decoration: none;
  transition: color 0.2s;
}

.breadcrumbs__link:hover {
  color: #c05e63;
  text-decoration: underline;
}

.breadcrumbs__current {
  color: #333;
  font-weight: 600;
}
</style>
